








































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
  ...mapGetters(["accountBook"]),
  components: {},
})
export default class VoucherImport extends Vue {
  @Prop({ type: String })
  period!: string;

  file: any = null;
  changeFile(e: any) {
    if (e.target.files[0]) {
      this.file = e.target.files[0];
    }
  }
  confirmInput() {
    if (this.file != null) {
      let data = new FormData();
      data.append("file", this.file);
      data.append("accountBookId", this.$store.state.accountBook.id);
      data.append("fileName", this.file.name);
      data.append("period", this.period);
      this.$emit("startUpload");
      let onkeyPut: any = document.querySelector("#OneKeyPut");
      if (data) {
        Vue.axios
          .post(`upload/voucher`, data)
          .then((res) => {
            this.file = null;
            onkeyPut.value = "";
            this.$emit("finish", res.data);
          })
          .catch((res) => {
            data = new FormData();
            onkeyPut.value = "";
          });
      }
    } else {
      this.$message("亲,请选择文件");
    }
  }
  close() {
    this.$emit("close");
  }
}
